export const ATTRIBUTION_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid", "msclkid"] as const;

const FIRST_TOUCH_COOKIE = "first_touch";
const MAX_LEN = 200;
const MAX_AGE = 60 * 60 * 24 * 90;

export function keepFirstTouch(doc: { cookie: string } = document, location: { search: string; hostname: string } = window.location) {
  if (doc.cookie.split("; ").some((row) => row.startsWith(`${FIRST_TOUCH_COOKIE}=`))) return;
  const params = new URLSearchParams(location.search);
  const touch = Object.fromEntries(
    ATTRIBUTION_KEYS.flatMap((key) => {
      const value = params.get(key);
      return value ? [[key, value.slice(0, MAX_LEN)]] : [];
    }),
  );
  if (!Object.keys(touch).length) return;
  const domain = location.hostname.endsWith("pandahub.com") ? "; domain=.pandahub.com" : "";
  doc.cookie = `${FIRST_TOUCH_COOKIE}=${encodeURIComponent(JSON.stringify(touch))}; path=/${domain}; max-age=${MAX_AGE}; SameSite=Lax`;
}

export const loadsProductionTracking = () => process.env.NEXT_PUBLIC_APP_RUN_MODE === "production";
